var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser && !_vm.currentUser.confirmed)?_c('div',{staticClass:"unconfirmed-message"},[_vm._v(" Your Community account setup is incomplete. Please check your inbox or spam folder for an email to claim your account. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }